import { FC } from 'react';
import { toGovernancePolicy } from '@agilelab/plugin-wb-governance';
import { TestStatus, WbTag } from '@agilelab/plugin-wb-platform';
import { TableCell, TableRow, Typography } from '@material-ui/core';
import { Task } from '../../ControlPanel';
import { useStyles } from './styles';
import { PolicyDetailDrawerContent } from '../../common';
import { PolicyGql } from '@agilelab/plugin-wb-governance-common';
import { useValidationTestDrawerContext } from './ValidationTestDrawerContext';

interface Props {
  task: Task;
  policy: PolicyGql;
}

export const PolicyRow: FC<Props> = ({ task, policy }) => {
  const classes = useStyles();
  const { setValidationTestResultDetailContent, setValidationTestResultOpen } =
    useValidationTestDrawerContext();
  const onRowClick = () => {
    setValidationTestResultDetailContent(
      <PolicyDetailDrawerContent
        task={task}
        policy={toGovernancePolicy(policy)}
      />,
    );
    setValidationTestResultOpen(true);
  };

  return (
    <TableRow onClick={onRowClick} className={classes.row}>
      <TableCell width="20%">
        <TestStatus
          status={task.status}
          filled
          severity={policy.content.severity}
          policyStatus={task.governanceEntityStatus}
        />
      </TableCell>
      <TableCell width="30%">
        <Typography style={{ fontWeight: 700 }}>
          {policy.name} - {policy.version}
        </Typography>
      </TableCell>
      <TableCell width="30%">
        <Typography>{policy.description}</Typography>
      </TableCell>
      <TableCell width="20%" align="right">
        <WbTag
          tag={{
            tagFQN: 'Policy',
          }}
        />
      </TableCell>
    </TableRow>
  );
};
